import PortalRequestsListView from "../../components/portal/PortalRequestsListView";

const PortalBookings = () => {
    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap">
                    <PortalRequestsListView
                        stageOptions={[
                            "Handed to Ops",
                            "Preliminary brief",
                            "Passports & catering",
                            "Confirmed with operator",
                            "Final brief",
                        ]}
                    />
                </div>
            </section>
        </>
    );
};

export default PortalBookings;
